module.exports = __webpack_public_path__ + "static/media/participant_status_enrollment.154c40bf.svg";